import { render, staticRenderFns } from "./userinfon.vue?vue&type=template&id=131aba8e&scoped=true&"
import script from "./userinfon.vue?vue&type=script&lang=js&"
export * from "./userinfon.vue?vue&type=script&lang=js&"
import style0 from "./userinfon.vue?vue&type=style&index=0&id=131aba8e&scoped=true&lang=less&"
import style1 from "./userinfon.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131aba8e",
  null
  
)

export default component.exports